export default () => {
	return {
		suggestionList: [
			"Automotive",
			"Consumer Discretionary",
			"Consumer Goods",
			"Household Durables",
			"Leisure Products",
			"Textiles, Apparel & Luxury Goods",
			"Diversified Consumer Services",
			"Hotels, Restaurants & Leisure",
			"Education Services",
			"Family Services",
			"Specialized Consumer Services",
			"Media",
			"Distributors",
			"Retailing",
			"Specialty Retail",
			"Consumer Staples",
			"Beverages",
			"Food Products",
			"Personal Products",
			"Gas Utilities",
			"Banks",
			"Diversified Financial Services",
			"Capital Markets",
			"Insurance",
			"Real Estate",
			"Health Care Providers & Services",
			"Biotechnology",
			"Pharmaceuticals",
			"Aerospace & Defense",
			"Commercial Services & Supplies",
			"Construction & Engineering",
			"Electrical Equipment",
			"Industrial Conglomerates",
			"Machinery",
			"Trading Companies & Distributors",
			"Professional Services",
			"Air Freight & Logistics",
			"Airlines",
			"Marine",
			"Transportation",
			"Internet Software & Services",
			"IT Services",
			"Communications Equipment",
			"Electronic Equipment, Instruments & Components",
			"Technology Hardware, Storage & Peripherals",
			"Building Materials",
			"Chemicals",
			"Containers & Packaging",
			"Metals & Mining",
			"Paper & Forest Products",
			"Diversified Telecommunication Services",
			"Renewable Electricity",
			"Electric Utilities",
			"Utilities"
		],
		industries: [
			{
				name: 'Automotive',
				isSelected: false,
				sub: [
					{ name: "Automotive", isSelected: false },
				]
			},
			{
				name: 'Consumer Discretionary',
				isSelected: false,
				sub: [
					{ name: "Consumer Discretionary", isSelected: false },
				]
			},

			{
				name: 'Consumer Goods',
				isSelected: false,
				sub: [
					{ name: "Consumer Goods", isSelected: false },
				]
			},
			{
				name: 'Household Durables',
				isSelected: false,
				sub: [
					{ name: "Consumer Electronics", isSelected: false },
					{ name: "Household Appliances", isSelected: false },
					{ name: "Photography", isSelected: false }
				]
			},
			{
				name: 'Leisure Products',
				isSelected: false,
				sub: [
					{ name: "Leisure Facilities", isSelected: false },
					{ name: "Sporting Goods", isSelected: false },
				]
			},
			{
				name: 'Textiles, Apparel & Luxury Goods',
				isSelected: false,
				sub: [
					{ name: "Apparel, Accessories & Luxury Goods", isSelected: false },
					{ name: "Textiles", isSelected: false },
					{ name: "Textiles, Apparel & Luxury Goods", isSelected: false }
				]
			},
			{
				name: 'Diversified Consumer Services',
				isSelected: false,
				sub: [
					{ name: "Education Services", isSelected: false },
					{ name: "Specialized Consumer Services", isSelected: false },
				]
			},
			{
				name: 'Hotels, Restaurants & Leisure',
				isSelected: false,
				sub: [
					{ name: "Casinos & Gaming", isSelected: false },
					{ name: "Hotels, Restaurants & Leisure", isSelected: false },
					{ name: "Leisure Facilities", isSelected: false },
					{ name: "Restaurants", isSelected: false },
				]
			},
			{
				name: 'Education Services',
				isSelected: false,
				sub: [
					{ name: "Education", isSelected: false },
				]
			},
			{
				name: 'Family Services',
				isSelected: false,
				sub: [
					{ name: "Family Services", isSelected: false },
				]
			},
			{
				name: 'Specialized Consumer Services',
				isSelected: false,
				sub: [
					{ name: "Legal Services", isSelected: false },
				]
			},
			{
				name: 'Media',
				isSelected: false,
				sub: [
					{ name: "Advertising", isSelected: false },
					{ name: "Broadcasting", isSelected: false },
					{ name: "Media", isSelected: false },
					{ name: "Movies & Entertainment", isSelected: false },
					{ name: "Public Relations", isSelected: false },
					{ name: "Publishing", isSelected: false },
				]
			},
			{
				name: 'Distributors',
				isSelected: false,
				sub: [
					{ name: "Distributors", isSelected: false },
				]
			},
			{
				name: 'Retailing',
				isSelected: false,
				sub: [
					{ name: "Retailing", isSelected: false },
				]
			},
			{
				name: 'Specialty Retail',
				isSelected: false,
				sub: [
					{ name: "Home Improvement Retail", isSelected: false },
					{ name: "Homefurnishing Retail", isSelected: false },
					{ name: "Specialty Retail", isSelected: false },
				]
			},
			{
				name: 'Consumer Staples',
				isSelected: false,
				sub: [
					{ name: "Consumer Staples", isSelected: false },
				]
			},
			{
				name: 'Beverages',
				isSelected: false,
				sub: [
					{ name: "Beverages", isSelected: false },
				]
			},
			{
				name: 'Food Products',
				isSelected: false,
				sub: [
					{ name: "Agricultural Products", isSelected: false },
					{ name: "Food", isSelected: false },
					{ name: "Food Production", isSelected: false },
					{ name: "Packaged Foods & Meats", isSelected: false },
				]
			},
			{
				name: 'Personal Products',
				isSelected: false,
				sub: [
					{ name: "Cosmetics", isSelected: false },
				]
			},
			{
				name: 'Gas Utilities',
				isSelected: false,
				sub: [
					{ name: "Oil & Gas", isSelected: false },
				]
			},
			{
				name: 'Banks',
				isSelected: false,
				sub: [
					{ name: "Banking & Mortgages", isSelected: false },
				]
			},
			{
				name: 'Diversified Financial Services',
				isSelected: false,
				sub: [
					{ name: "Accounting", isSelected: false },
					{ name: "Finance", isSelected: false },
					{ name: "Financial Services", isSelected: false },
					{ name: "Payments", isSelected: false },
				]
			},
			{
				name: 'Capital Markets',
				isSelected: false,
				sub: [
					{ name: "Asset Management & Custody Banks", isSelected: false },
					{ name: "Diversified Capital Markets", isSelected: false },
					{ name: "Fundraising", isSelected: false },
					{ name: "Investment Banking & Brokerage", isSelected: false },
				]
			},
			{
				name: 'Insurance',
				isSelected: false,
				sub: [
					{ name: "Insurance", isSelected: false },
				]
			},
			{
				name: 'Real Estate',
				isSelected: false,
				sub: [
					{ name: "Real Estate", isSelected: false },
				]
			},
			{
				name: 'Health Care Providers & Services',
				isSelected: false,
				sub: [
					{ name: "Health & Wellness", isSelected: false },
					{ name: "Health Care", isSelected: false },
					{ name: "Health Care Services", isSelected: false },
				]
			},
			{
				name: 'Biotechnology',
				isSelected: false,
				sub: [
					{ name: "Biotechnology", isSelected: false },
				]
			},
			{
				name: 'Pharmaceuticals',
				isSelected: false,
				sub: [
					{ name: "Pharmaceuticals", isSelected: false },
				]
			},
			{
				name: 'Aerospace & Defense',
				isSelected: false,
				sub: [
					{ name: "Aerospace & Defense", isSelected: false },
				]
			},
			{
				name: 'Construction & Engineering',
				isSelected: false,
				sub: [
					{ name: "Civil Engineering", isSelected: false },
					{ name: "Construction", isSelected: false },
					{ name: "Construction & Engineering", isSelected: false },
					{ name: "Mechanical Engineering", isSelected: false },
				]
			},
			{
				name: 'Electrical Equipment',
				isSelected: false,
				sub: [
					{ name: "Electrical", isSelected: false },
					{ name: "Electrical Equipment", isSelected: false },
				]
			},
			{
				name: 'Industrial Conglomerates',
				isSelected: false,
				sub: [
					{ name: "Industrials & Manufacturing", isSelected: false },
				]
			},
			{
				name: 'Machinery',
				isSelected: false,
				sub: [
					{ name: "Industrial Machinery", isSelected: false },
					{ name: "Machinery", isSelected: false },
				]
			},
			{
				name: 'Trading Companies & Distributors',
				isSelected: false,
				sub: [
					{ name: "Trading Companies & Distributors", isSelected: false },
				]
			},
			{
				name: 'Commercial Services & Supplies',
				isSelected: false,
				sub: [
					{ name: "Business Supplies", isSelected: false },
					{ name: "Commercial Printing", isSelected: false },
					{ name: "Corporate & Business", isSelected: false },
				]
			},
			{
				name: 'Professional Services',
				isSelected: false,
				sub: [
					{ name: "Architecture", isSelected: false },
					{ name: "Automation", isSelected: false },
					{ name: "Consulting", isSelected: false },
					{ name: "Design", isSelected: false },
					{ name: "Human Resource & Employment Services", isSelected: false },
					{ name: "Professional Services", isSelected: false },
					{ name: "Research & Consulting Services", isSelected: false },
				]
			},
			{
				name: 'Air Freight & Logistics',
				isSelected: false,
				sub: [
					{ name: "Shipping & Logistics", isSelected: false },
				]
			},
			{
				name: 'Airlines',
				isSelected: false,
				sub: [
					{ name: "Airlines", isSelected: false },
				]
			},
			{
				name: 'Marine',
				isSelected: false,
				sub: [
					{ name: "Marine", isSelected: false },
				]
			},
			{
				name: 'Transportation',
				isSelected: false,
				sub: [
					{ name: "Transportation", isSelected: false },
				]
			},
			{
				name: 'Internet Software & Services',
				isSelected: false,
				sub: [
					{ name: "Cloud Services", isSelected: false },
					{ name: "Internet", isSelected: false },
					{ name: "Internet Software & Services", isSelected: false },
				]
			},
			{
				name: 'IT Services',
				isSelected: false,
				sub: [
					{ name: "Data Processing & Outsourced Services", isSelected: false },
				]
			},
			{
				name: 'Communications Equipment',
				isSelected: false,
				sub: [
					{ name: "Communications", isSelected: false },
					{ name: "Computer Networking", isSelected: false },
				]
			},
			{
				name: 'Electronic Equipment, Instruments & Components',
				isSelected: false,
				sub: [
					{ name: "Nanotechnology", isSelected: false },
				]
			},
			{
				name: 'Technology Hardware, Storage & Peripherals',
				isSelected: false,
				sub: [
					{ name: "Computer Hardware", isSelected: false },
					{ name: "Technology Hardware, Storage & Peripherals", isSelected: false },
				]
			},
			{
				name: 'Building Materials',
				isSelected: false,
				sub: [
					{ name: "Building Materials", isSelected: false },
				]
			},
			{
				name: 'Chemicals',
				isSelected: false,
				sub: [
					{ name: "Chemicals", isSelected: false },
					{ name: "Commodity Chemicals", isSelected: false },
				]
			},
			{
				name: 'Containers & Packaging',
				isSelected: false,
				sub: [
					{ name: "Containers & Packaging", isSelected: false },
				]
			},
			{
				name: 'Metals & Mining',
				isSelected: false,
				sub: [
					{ name: "Gold", isSelected: false },
					{ name: "Metals & Mining", isSelected: false },
				]
			},
			{
				name: 'Paper & Forest Products',
				isSelected: false,
				sub: [
					{ name: "Paper Products", isSelected: false },
				]
			},
			{
				name: 'Diversified Telecommunication Services',
				isSelected: false,
				sub: [
					{ name: "Integrated Telecommunication Services", isSelected: false },
				]
			},
			{
				name: 'Renewable Electricity',
				isSelected: false,
				sub: [
					{ name: "Renewable Electricity", isSelected: false },
				]
			},
			{
				name: 'Electric Utilities',
				isSelected: false,
				sub: [
					{ name: "Energy", isSelected: false },
				]
			},
			{
				name: 'Utilities',
				isSelected: false,
				sub: [
					{ name: "Utilities", isSelected: false },
				]
			}
		]
	}
};

/*
["Airlines/Aviation"],
["Alternative Dispute Resolution"],
["Alternative Medicine"],

["Apparel & Fashion"],


["Automotive"],
["Aviation & Aerospace"],
["Banking"],
["Biotechnology"],
["Broadcast Media"],

["Business Supplies and Equipment"],
["Capital Markets"],
["Chemicals"],
["Civic & Social Organization"],


["Computer & Network Security"],
["Computer Games"],
["Computer Hardware"],
["Computer Networking"],
["Computer Software"],

["Consumer Electronics"],
["Consumer Goods"],
["Consumer Services"],
["Cosmetics"],
["Defense & Space"],

["Education Management"],
["eCommerce"],
["E-Learning"],
["Electrical/Electronic Manufacturing"],
["Entertainment"],
["Environmental Services"],
["Events Services"],
["Executive Office"],
["Facilities Services"],
["Financial Services"],

["Food & Beverages"],
["Food Production"],
["Fund-Raising"],
["Furniture"],
["Gambling & Casinos"],

["Government Administration"],
["Government Relations"],

["Health"],
["Higher Education"],
["Hospital & Health Care"],
["Hospitality"],
["Human Resources"],
["Import and Export"],
["Individual & Family Services"],

["Information Services"],
["Information Technology and Services"],
["Insurance"],
["International Affairs"],
["International Trade and Development"],
["Internet"],
["Investment Banking"],
["Investment Management"],
["Judiciary"],
["Law Enforcement"],
["Law Practice"],
["Legal Services"],
["Legislative Office"],
["Leisure"],
["Libraries"],
["Logistics and Supply Chain"],
["Luxury Goods & Jewelry"],
["Machinery"],
["Management Consulting"],
["Maritime"],
["Marketing and Advertising"],
["Market Research"],

["Media Production"],
["Medical Devices"],
["Medical Practice"],
["Mental Health Care"],
["Military"],
["Mining & Metals"],



["Nanotechnology"],
["Newspapers"],
["Nonprofit Organization Management"],
["Oil & Energy"],
["Online Media"],
["Outsourcing/Offshoring"],
["Package/Freight Delivery"],
["Packaging and Containers"],
["Paper & Forest Products"],

["Pharmaceuticals"],
["Philanthropy"],

["Plastics"],
["Political Organization"],
["Primary/Secondary Education"],
["Printing"],
["Professional Training & Coaching"],
["Program Development"],
["Public Policy"],
["Public Relations and Communications"],
["Public Safety"],
["Publishing"],
["Railroad Manufacture"],


["Recreational Facilities and Services"],
["Religious Institutions"],
["Renewables & Environment"],
["Research"],
["Restaurants"],
["Retail"],
["SaaS"],
["Security and Investigations"],
["Semiconductors"],
["Shipbuilding"],
["Sporting Goods"],
["Sports"],
["Staffing and Recruiting"],
["Supermarkets"],
["Telecommunications"],
["Textiles"],
["Think Tanks"],
["Tobacco"],
["Translation and Localization"],
["Transportation/Trucking/Railroad"],
["Utilities"],
["Venture Capital & Private Equity"],
["Veterinary"],
["Warehousing"],
["Wholesale"],
["Wine and Spirits"],
["Wireless"],
*/
